import {
  createStyles,
  Title,
  Text,
  Space,
  Anchor,
  Image,
  Box,
  Divider,
} from '@mantine/core';
import { themeColors } from '../../config/themeSettings';

const PoliceAppLaunch = () => {
  const { classes } = useStyles();

  return (
    <div>
      <div className={classes.dateCategory}>
        November 06, 2025 | India News
      </div>
      <section className={classes.header}>
        <Title order={1} className={classes.title}>
          Police a tap away for women and elderly. Just 'Say Help'
        </Title>
      </section>
      <div className={classes.container}>
        <Box className={classes.sectionCenter}>
          <Image src="https://static.toiimg.com/thumb/msid-125116262,imgsize-21232,width-400,height-225,resizemode-72/police-a-tap-away-for-women-and-elderly-just-say-help.jpg" />
          <div className={classes.imageAttribution}>
            Image from Times of India
          </div>

          <section className={classes.paragraph}>
            <Space h="md" />
            <Text>
              <strong>New Delhi:</strong> When a 20-year-old Delhi University student and her classmates were harassed near GB Road one September evening, their quick thinking — and a mobile app — made all the difference. With a single tap on Say Help, a new police assistance app, the young woman sent out a distress alert. Within 4.5 minutes, a police team arrived and detained the three men responsible. That swift response wasn't a one-off.
            </Text>
            <Space h="md" />
            <Text>
              In the narrow lanes and crowded markets of Old Delhi — neighbourhoods like Jama Masjid, Hauz Qazi and Paharganj — women, senior citizens and even men are increasingly relying on the Say Help app to reach the police instantly. Launched in September this year as a pilot project, the app has already helped police respond to or solve at least six cases ranging from harassment and domestic violence to human trafficking and cyber threats.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Real Cases, Real Impact
            </Title>
            <Space h="md" />
            <Text>
              In another case on Oct 29, a woman from Noida used the app to seek help after being abused by her husband. Delhi Police coordinated with their Uttar Pradesh counterparts, ensuring immediate intervention. "During inquiry, it was found that she had been subjected to domestic abuse," an officer said.
            </Text>
            <Space h="md" />
            <Text>
              Sometimes, alerts come in unexpectedly. On Sept 16, a 72-year-old woman in Ram Nagar accidentally triggered an alert while demonstrating the app to her daughter. Within 19 minutes, police were at her door, checking to ensure she was safe.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Busting Serious Crimes
            </Title>
            <Space h="md" />
            <Text>
              The app has also played a key role in busting serious crimes. On Oct 31, police raided a spa in Paharganj after receiving an alert about a prostitution racket being run there. Six women were rescued, and the operators — a woman and her husband — were arrested under the Immoral Trafficking Act.
            </Text>
            <Space h="md" />
            <Text>
              It's not just women who are using the app. On Oct 15, a 74-year-old Baljit Nagar resident raised multiple alerts after getting a threatening call faking his daughter's number. The alert was routed to Anand Parbat police, and the SHO personally intervened to assist him. In another instance, a 38-year-old man sought help through the app after a heated argument with a street vendor in Mithaipul.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Growing Adoption and Future Plans
            </Title>
            <Space h="md" />
            <Text>
              DCP (Central) Nidhin Valsan said the app is gradually changing how residents seek police help. "We launched Say Help as a pilot and around 12,000 people have downloaded it so far. We're reaching out to schools, colleges, coaching centres and restaurants to raise awareness," he said.
            </Text>
            <Space h="md" />
          </section>
          <Divider></Divider>
          <Text className={classes.footNote}>
            Story by{' '}
            <Anchor href="https://timesofindia.indiatimes.com/toireporter/author-abhay-479264520.cms" target="_blank">
              Abhay
            </Anchor>
            . Source:{' '}
            <Anchor href="http://timesofindia.indiatimes.com/articleshow/125116263.cms" target="_blank">
              Times of India
            </Anchor>
          </Text>
        </Box>
      </div>
    </div>
  );
};

export default PoliceAppLaunch;

const useStyles = createStyles(theme => ({
  root: {
    fontFamily: 'Poppins',
    backgroundColor: themeColors.white,
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
  },

  dateCategory: {
    fontSize: 14,
    fontWeight: 'normal',
    marginBottom: 10,
    textAlign: 'center',
    color: '#757575',
  },

  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
  },

  footNote: {
    fontSize: 12,
    marginTop: 20,
    color: '#757575',
  },

  imageAttribution: {
    fontSize: 12,
    marginTop: 10,
    color: '#757575',
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  titleLeft: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  paragraph: {
    fontFamily: 'Poppins',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },
}));
